import { Pipe } from "@angular/core";
export var DecodeHtmlEntities = (function () {
    function DecodeHtmlEntities() {
    }
    DecodeHtmlEntities.prototype.transform = function (value, args) {
        if (!value)
            return;
        var txt = document.createElement("textarea");
        txt.innerHTML = value;
        return txt.value;
    };
    DecodeHtmlEntities.decorators = [
        { type: Pipe, args: [{
                    name: 'decodeHtmlEntities'
                },] },
    ];
    /** @nocollapse */
    DecodeHtmlEntities.ctorParameters = function () { return []; };
    return DecodeHtmlEntities;
}());
//# sourceMappingURL=decode-html-entities.Pipe.js.map